module.exports = __webpack_public_path__ + "static/media/wonder-woman@2x.5fd581cd.png";